import { Component, signal, output, effect, Input } from '@angular/core';
import { SearchBarComponent } from '@/app/shared/search-bar/search-bar.component';
import { DescriptionCardComponent } from '@/app/shared/cards/description-card/description-card.component';
import { ServiceWithActions } from '@/app/interfaces/service';
import { ServicesService } from '@/app/services/services.service';
import { Service } from '@/app/interfaces/service';
import { PaginationComponent } from '@/app/shared/pagination/pagination.component';
import { environment } from '@/environments/environment';
@Component({
  selector: 'app-step2',
  imports: [SearchBarComponent, DescriptionCardComponent, PaginationComponent],
  templateUrl: './step2.component.html',
})
export class Step2Component {
  constructor(private servicesService: ServicesService) {}
  @Input() organismCode: string;
  @Input() nameProtocol: string;
  servicesEffect = effect(() => {
    this.currentPage();
    this.paginationSize();
    this.services.set([]);
    this.loadServices();
  });
  jobCode = JSON.parse(localStorage.getItem('userData')).roleCode;
  orgCode = JSON.parse(localStorage.getItem('userData')).orgCode;
  seachData = signal('');
  paginationSize = signal(15);
  currentPage = signal(1);
  dataChange = output<Service>();
  totalResults = signal(0);
  services = signal<ServiceWithActions[]>([]);
  urlDetail = signal<string>('');
  get filterParams() {
    return [
      {
        basicFilter: {
          orderBy: 'asc',
          nameOrderBy: '',
          currentPage: this.currentPage(),
          sizePages: this.paginationSize(),
          jobCode: this.jobCode,
        },
      },
      {
        advanceFilter: {
          search: this.seachData(),
        },
      },
    ];
  }

  handleSearch(value: string) {
    this.seachData.set(value);
  }

  setUrlDetail(data) {
    const url = environment.urlDetail;
    if (data.parentProcedureCode === null) {
      this.urlDetail.set(url + '/' + data.id);
    } else {
      this.urlDetail.set(url + '/' + data.parentProcedureCode + '/child' + data.id);
    }
  }

  selectService(service: Service) {
    if (!service?.id) {
      return;
    }
    this.dataChange.emit(service);
  }

  async loadServices() {
    const data = await this.servicesService.getServices(this.filterParams);
    if (data?.items?.length) {
      const servicesWithActions = data.items.map(
        (service) => (
          this.setUrlDetail(service),
          {
            ...service,
            actions: [
              {
                label: 'Seleccionar',
                type: 'button',
                action: () => this.selectService(service),
              },
            ],
          }
        )
      );
      this.services.set(servicesWithActions);
    } else {
      this.services.set([]);
    }
    this.totalResults.set(data.total);
  }
}
